











































































































import { Component, Provide, Prop, Vue } from 'vue-property-decorator';
import { isEqual } from 'lodash';
import { TForm } from '@/plugins/podolib/lib/types';
import { TAcquisition, TComment, TGraph, TPatient } from '@/plugins/podolib/services/entities/EntityPatients';
import { TEntity } from '@/plugins/podolib/services/entities/Entity';
import { Severity } from '@sentry/types';
//
import PatientAcquisitionCommentsEdit from '@/components/patients/PatientAcquisitionCommentsEdit.vue';

type TFields = {
  comment: {
    value: string;
  };
};
@Component({
  components: {
    PatientAcquisitionCommentsEdit,
  },
})
export default class PatientAcquisitionComments extends Vue {
  @Prop({ required: true }) private comments!: TComment[] | null;
  @Prop({ required: true }) private patientId!: string;
  @Prop({ required: true }) private acquisition!: TAcquisition;
  @Prop({ default: null, required: false }) private select!: TGraph;

  @Provide() form: TForm<TFields> = {
    fields: {
      comment: {
        value: '',
      },
    },
    pending: false,
    error: null,
    success: false,
  };

  @Provide() deletion = {
    pending: false,
    success: false,
    error: null,
  };

  get doctor() {
    return this.$pdc.doctor!.current;
  }

  get initials() {
    return this.doctor.firstName.slice(0, 1) + this.doctor.lastName.slice(0, 1);
  }

  /**
   * Save new comment
   */
  async saveNewComment() {
    try {
      // @ts-ignore
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;
      // Blur
      (this.$refs.comment as any).blur();
      // Reset flags
      this.form.success = false;
      this.form.error = null;
      this.deletion.success = false;
      this.deletion.error = null;
      // Set 'pending' flag
      this.form.pending = true;
      // Try to patch the station ...
      await this.$pdc.repository!.patchRessource({
        ressource: 'acquisitions',
        params: {
          _id: this.acquisition._id,
        },
        data: {
          $push: {
            comments: {
              comment: this.form.fields.comment.value,
            },
          },
        },
      });
      this.form.success = true;
      // Reset field
      this.clear();
    } catch (e) {
      this.form.error = e;
      // Sentry
      this.$sentry.captureMessage(e.message, Severity.Error);
    } finally {
      // Reset 'pending' flag
      this.form.pending = false;
    }
  }

  /**
   * Delete comment
   */
  async deleteComment(commentId: TComment['_id']) {
    try {
      // Reset flags
      this.deletion.success = false;
      this.deletion.error = null;
      // Set 'pending' flag
      this.deletion.pending = true;
      // Try to patch the station ...

      await this.$pdc.repository!.patchRessource({
        ressource: 'acquisitions',
        params: {
          _id: this.acquisition._id,
        },
        data: {
          $pull: {
            comments: {
              _id: commentId,
            },
          },
        },
      });
      this.deletion.success = true;
    } catch (e) {
      this.deletion.error = e;
      // Sentry
      this.$sentry.captureMessage(e.message, Severity.Error);
    } finally {
      // Reset 'pending' flag
      this.deletion.pending = false;
    }
  }

  clear() {
    (this.$refs.form as Vue & { reset: () => void }).reset();
    requestAnimationFrame(() => {
      (this.$refs.observer as Vue & { reset: () => void }).reset();
    });
  }
  breakLine(val: string) {
    return val.replace(/(\r\n|\n)/g, '<br/>');
  }
}
